'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    // WRITE YOUR CODE HERE
    var ul = document.createElement('ul');
    var keys = Object.keys(data);
    keys.forEach(function(key) {
        if (data[key] === null) return;
        var li = document.createElement('li');
        li.textContent = key;
        ul.appendChild(li);
        createTree(li, data[key]);
    });
    if (ul.children.length > 0) element.appendChild(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.d345a5bc.js.map
